export default "__VITE_ASSET__0f1b4ad7__"